// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/hr/dispositivi-aziendali/:id',
    requestBody: null,
    response: '{success:true,data:{id,societaId,codiceMatricola,tipologia,marca,modello,seriale,partNumber,proprieta,fornitore,fornitoreDescrizione,dataFatturaAcquisto,numeroFatturaAcquisto,importoAcquisto,causaleTerzi,proprietario,proprietarioDescrizione,dataRicezione,numeroDdtRicezione,dataDdtRicezione,ubicazioneCorrente,stato,assegnazioneAttiva,storicoAssegnazioni,storicoUbicazioni,note}}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/dispositivi-aziendali/nominativi-lista?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,codice,descrizione,partitaIva,ruolo}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi/dipendenti-lista?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,cognome,mansione,stato}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/hr/dispositivi-aziendali/:id',
    requestBody: '{codiceMatricola,tipologiaId,marca,modello,seriale,partNumber,proprieta,fornitoreId,fornitoreDescrizione,numeroFatturaAcquisto,dataFatturaAcquisto,importoAcquisto,causaleTerziId,proprietarioId,proprietarioDescrizione,dataRicezione,numeroDdtRicezione,dataDdtRicezione}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'PATCH',
    endpoint: '/api/hr/dispositivi-aziendali/:id/dismetti',
    requestBody: null,
    response: '{success:true,data:{id,stato}}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/assegnazioni-dispositivi',
    requestBody: '{societaId,dispositivoId,dipendenteId,dataAssegnazione,consegnatoId,note}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/verbale',
    requestBody: '{verbale:file}',
    response: '{success:true,data:{verbaleGcsPath,verbaleFileName}}'
  },
  {
    method: 'PATCH',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/restituzione',
    requestBody: '{dataRestituzione,noteRestituzione}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/verbale',
    requestBody: null,
    response: '(file stream)'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/dispositivi-aziendali/:id/ubicazioni',
    requestBody: '{ubicazioneAId,dataSpostamento,note}',
    response: '{success:true,data:{id,ubicazioneDa,ubicazioneA,dataSpostamento,note,utenteNome}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/hr/dispositivi-aziendali/:id/ubicazioni/:movimentoId',
    requestBody: null,
    response: '{success:true}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/dispositivi-aziendali/:id/note',
    requestBody: '{testo}',
    response: '{success:true,data:{id,testo,autoreNome,createdAt}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/hr/dispositivi-aziendali/:id/note/:notaId',
    requestBody: '{testo}',
    response: '{success:true,data:{id,testo}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/hr/dispositivi-aziendali/:id/note/:notaId',
    requestBody: null,
    response: '{success:true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
